import { useEffect } from "react";
import { Popover, Box, Typography, Divider, IconButton } from "@mui/material";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import { useLogOut } from "@src/entities/login/model/hooks/useLogOut/useLogOut";
import { NavLink, useLocation } from "react-router-dom";
import {
  dictionaryNamesTariffs,
  INamesTariffs,
} from "@src/features/tariff-selection/ui/utils";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./UserPopover.module.scss";

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
}

//Изменить отображение пакетов отработанных попыток и оставшихся

export const UserPopover = ({ anchorEl, onClose, open }: Props) => {
  const { mutate: logOut } = useLogOut();
  const userAuth = useAuthStore((state) => state.user);
  const userMe = useUserInfoMeStore((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    onClose();
  }, [location.pathname]);

  const handleLogOut = () => logOut();

  const fullName =
    userMe?.first_name && userMe?.last_name
      ? `${userMe.last_name} ${userMe.first_name} ${userMe.middle_name ?? ""}`
      : userAuth?.user?.username;

  const { availableAttempts } = (userMe?.owned_licenses || []).reduce(
    (acc, license) => {
      const { available_attempts, used_request } = license;

      if (license.is_active) {
        const remainingAttempts = available_attempts - used_request;
        acc.availableAttempts += remainingAttempts;
      }

      return acc;
    },
    { availableAttempts: 0, attemptsUsed: 0 }
  );

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ className: styles.paper }}
      disableEnforceFocus
    >
      <Box className={styles.wrapper}>
        <Box className={styles.header}>
          <Typography className={styles.name}>{fullName || ""}</Typography>
          <Typography className={styles.email}>
            {userMe?.email || ""}
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            className={styles.close}
            sx={{
              position: "absolute",
              top: "-12px",
              right: "-10px",
              zIndex: 100,
            }}
          >
            <CloseIcon
              sx={{
                width: "10px",
                height: "10px",
                color: "rgba(255, 255, 255, 0.5)",
              }}
            />
          </IconButton>
        </Box>

        <Box className={styles.stats}>
          <Box className={styles.cell}>
            <span>Текущий тариф</span>
            <strong>
              {dictionaryNamesTariffs[userMe?.package?.name as INamesTariffs]
                ?.title || "-"}
            </strong>
          </Box>
          <Box className={styles.cell}>
            <span>Доступно попыток</span>
            <strong>{availableAttempts}</strong>
          </Box>
          <Box className={styles.cell}>
            <span>Обработано запросов на ранжирование</span>
            <strong>{userMe?.ranking_requests || 0}</strong>
          </Box>
          <Box className={styles.cell}>
            <span>Обработано запросов на подбор</span>
            <strong>{userMe?.matching_requests || 0}</strong>
          </Box>
        </Box>

        <Divider />
        <Box className={styles.links}>
          <NavLink to="/personal-cab" className={styles.cabInfo}>
            Личный кабинет
          </NavLink>
          <NavLink to="/select-tariff" className={styles.cabInfo}>
            Выбрать тариф
          </NavLink>
          <NavLink to="/feedback" className={styles.cabInfo}>
            Отзыв о продукте
          </NavLink>
          <span className={`${styles.cabInfo} ${styles.disabledLink}`}>
            Анкетные данные
          </span>
          <button onClick={handleLogOut} className={styles.btn}>
            Выйти
          </button>
        </Box>
      </Box>
    </Popover>
  );
};
